import { useRef, useEffect } from "react";

const Select2 = ({ setValue, parentElem = '', options = [], value }) => {
  const selectElem = useRef(null);
  const isInitialized = useRef(false); // برای جلوگیری از چندین‌بار اجرا

  const handleRenderOptions = () => {
    return (
      <>
        <option key="empty" value="">
          انتخاب کنید
        </option>
        {options.map((option) => (
          <option
            key={option.value}
            value={option.value ?? ''}
          >
            {option.name}
          </option>
        ))}
      </>
    );
  };

  useEffect(() => {
    const $select = window.$(selectElem.current);

    if (!isInitialized.current) {
      // مقدار دهی اولیه به select2
      $select.select2({
        dropdownParent: window.$(parentElem),
        placeholder: "انتخاب",
        allowClear: true, // اجازه پاک کردن انتخاب
      });

      // تنظیم مقدار اولیه به عنوان خالی
      $select.val(value || "").trigger("change");

      // اضافه کردن ایونت change
      $select.on("change", () => {
        setValue($select.val());
      });

      isInitialized.current = true;
    } else {
      // به‌روزرسانی مقدار select در صورت تغییر props
      $select.val(value || "").trigger("change");
    }

    return () => {
      // تخریب select2 زمانیکه کامپوننت unmount می‌شود
      if (isInitialized.current) {
        $select.select2("destroy");
        isInitialized.current = false;
      }
    };
  }, [parentElem, value]);

  return (
    <select
      className="select2 form-select form-select-lg"
      data-allow-clear="false"
      ref={selectElem}
    >
      {handleRenderOptions()}
    </select>
  );
};

export default Select2;
